import { isDevEnv, isTestEnv } from '../utils/env';

// 通用静态资源 CDN 域名（供业务代码使用）
// OSS 桶：https://oss.console.aliyun.com/bucket/oss-us-west-1/h5-reader-oss/object?spm=5176.8466032.bucket-list.50.473f1450V04hv6
export const STATIC_DOMAIN = `https://static.flicknovelcdn.com`;

// 图片资源 hosting 域名 https://image-tools.mytestdrama.com/index.html 工具上传
// OSS 桶：https://oss.console.aliyun.com/bucket/oss-us-west-1/c-common-img-hosting/object
export const IMG_HOSTING = 'https://static-img.flicknovelcdn.com/';
export const IMG_HOSTING_POPKON = 'https://static-img.popkondramacdn.com/';

// api域名 - 正式环境
export const API_PROD_BASE = `https://api-us.flicknovel.com`;

// api域名 - 测试环境
export const API_TEST_BASE = `https://api-c.mytestdrama.com`;

// api域名 - 开发环境
export const API_DEV_BASE = `https://api-c.mytestdrama.com`;

// 反馈图片上传 OSS 配置
export const OSS_FEEDBACK_UPLOAD_PREFIX = 'feedback/';
export const OSS_FEEDBACK_REGION = 'us-west-1';
export const OSS_FEEDBACK_BUCKET = 'c-common-user-feedback';

// 获取api域名
export const getApiBase = (): string => {
    if (isDevEnv) {
        return API_DEV_BASE;
    }
    if (isTestEnv) {
        return API_TEST_BASE;
    }
    return API_PROD_BASE;
};
